import type { DigitalSetup, Outcome, Priority } from '#lib/steps/state';

/**
 * The single source of truth for how each answer sways the recommendation.
 *
 * `weight` is summed by computeRecommendedVariant (positive leans Hosted, negative
 * leans Embedded); `reason` is the human-facing explanation getReasonText
 * surfaces for the strongest factor on the winning side. Keeping both on one
 * table stops the score and its explanation from drifting apart.
 */
export type WeightedOption = { weight: number; reason?: string };

export const OUTCOME_WEIGHTS: Record<Outcome, WeightedOption> = {
  'wellbeing-space': { weight: 2, reason: 'you want a dedicated space for your people' },
  'embedded-tools': { weight: -2, reason: 'you want to integrate into existing tools' },
  'not-sure': { weight: 0 },
};

export const DIGITAL_SETUP_WEIGHTS: Record<DigitalSetup, WeightedOption> = {
  'no-platform': { weight: 2, reason: 'you need somewhere to send your people' },
  'has-website': { weight: 1, reason: 'you have limited technical resources' },
  'has-dev-team': { weight: -2, reason: 'you have a development team' },
};

export const PRIORITY_WEIGHTS: Record<Priority, WeightedOption> = {
  speed: { weight: 1, reason: 'you want to get live quickly' },
  grow: { weight: 0.5 },
  integration: { weight: -2, reason: 'deep integration is your priority' },
};
